export default {
  storageManager: {
    type: 'null',
  },
  styleManager: {
    clearProperties: 1
  },
  selectorManager: {
    componentFirst: true
  },
}
